<script>
  import { onMount } from 'svelte';
  import { clickOutside } from './clickOutside';
  import { External, M } from '../../external';

  export let inputValue = '',
    onChange = () => {},
    options = [],
    service = { createContext: async (name) => {} };

  let isOpen = false;
  let filteredOptions = [];
  let previousSelectedOptionName = null;

  function handleInputChange(event) {
    inputValue = event.target.value;
    filterOptions();
  }

  function filterOptions() {
    filteredOptions = options.filter((option) => option.name?.toLowerCase().includes(inputValue.toLowerCase()));
  }

  function handleOptionSelect(option) {
    if (option.name === previousSelectedOptionName) {
      isOpen = false;
      return;
    }
    inputValue = option.name;
    previousSelectedOptionName = option.name;
    onChange(option);
    isOpen = false;
  }

  function handleInputBlur() {
    if (previousSelectedOptionName === inputValue) {
      isOpen = false;
      return;
    }
    const found = options.find((option) => option.name === inputValue);
    if (found) {
      handleOptionSelect(found);
    } else {
      createNewContext();
    }
    isOpen = false;
    filteredOptions = [...options];
  }

  async function createNewContext() {
    if (!inputValue) {
      return;
    }
    // A failed create must not land an undefined entry in the list: handleOptionSelect would
    // then read .name off it and take the whole settings panel down with it.
    let newContext = null;
    try {
      newContext = await service.createContext(inputValue);
    } catch (e) {
      newContext = null;
    }
    if (!newContext || !newContext.resourceId) {
      return;
    }
    options = [...options, newContext];
    handleOptionSelect(newContext);
    filterOptions();
  }

  function onInputEnter() {
    const found = options.find((option) => option.name === inputValue);
    if (found) {
      handleOptionSelect(found);
    } else {
      createNewContext();
    }
    isOpen = false;
  }

  onMount(() => {
    filteredOptions = [...options];
    if (inputValue) {
      previousSelectedOptionName = inputValue;
    }
    if (!inputValue && options.length > 0) {
      handleOptionSelect(options[0]);
    }
    console.debug(inputValue, onChange, options);
  });
</script>

<div use:clickOutside on:click_outside={handleInputBlur} class="wall-widget-dropdown">
  <input
    type="text"
    on:input={handleInputChange}
    on:focus={() => {
      isOpen = true;
    }}
    bind:value={inputValue}
    on:keyup={(e) => {
      e.key === 'Enter' || e.keyCode === 13 ? onInputEnter() : null;
    }} />
  <ul class:open={isOpen} class="dropdown-menu">
    {#if filteredOptions.length > 0}
      {#each filteredOptions as option (option.name)}
        <li
          on:keypress={() => {
            handleOptionSelect(option);
          }}
          on:click={() => {
            handleOptionSelect(option);
          }}>
          {option.name}
        </li>
      {/each}
      {#if inputValue.length > 0 && !filteredOptions.find((option) => option.name === inputValue)}
        <li on:keypress={createNewContext} on:click={createNewContext}>{External.format(M.NEW_THREAD, 'x', inputValue)}</li>
      {/if}
    {:else if inputValue.length > 0}
      <li on:keypress={createNewContext} on:click={createNewContext}>{External.format(M.NEW_THREAD, 'x', inputValue)}</li>
    {/if}
  </ul>
</div>
